import Mustache from 'mustache';
import getLanguage from './helper/get-language';
import AddSearchClient from 'addsearch-js-client';
const addSearchClient = new AddSearchClient('cf02247524988b873489b308db752054');
let timeout = null;
/**
 * Fetch and render AddSearch search results.
 *
 * @class SiteSearch
 * @param {string} type - Search type, "full-search" or "quick-search".
 */
class SiteSearch {
  constructor(type) {
    this.searchType = type;
    this.ajaxUrl = new URL('/stage-ajax/get-search-results', window.location.origin);
    this.searchParams = new URLSearchParams({'stage-language': getLanguage(), type });

    this.registerNavSearchInputType();
  }

  registerNavSearchInputType() {
    const navSearchInput = document.querySelector('#nav-site-search-input')
    if (navSearchInput) {
      navSearchInput.addEventListener('input', function() {
        clearTimeout(timeout);
      });
    }
  }

  /**
   * Check if current locale time is in-between the given time frame.
   *
   * @param  {string}  searchTerm - Search term to search by.
   * @return {Promise} Promise with search results.
   */

  async getSearchResults(searchTerm) {
    this.searchParams.set('search', searchTerm.trim());
    this.ajaxUrl.search = this.searchParams;

    return await (
      await fetch(this.ajaxUrl.toString())
    ).json();
  }

  /**
   * Render search results in each category.
   *
   * @param  {Object}    searchResults  - Search results grouped in categories.
   * @param  {array}     sortCategories - Categories to sort by result count.
   * @return {undefined}
   */

  renderSearchResults(searchResults, sortCategories = Object.keys(this.elements.resultCategories)) {
    Object.entries(searchResults.hits).forEach(([searchCategory, results]) => {
      const resultCategoryContainer = this.elements.resultCategories[searchCategory];

      // Render category results
      resultCategoryContainer.innerHTML = Mustache.render(this.templates[searchCategory], {
        [searchCategory]: results
      });

      // Set category container order
      if (sortCategories.includes(searchCategory)) {
        resultCategoryContainer.parentElement.style.order = -(results.length);
      }
    });

    this.registerSearchResultEvents();
  }

  /**
   * Register search result click events.
   * 
   * @return {undefined}
   */
  registerSearchResultEvents() {

    const getSearchValue = (isNavSearchResultClicked) => {
      if (isNavSearchResultClicked) {
        return document.getElementById('nav-site-search-input').value
      } else {
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        return params.get('search');
      }
    }

    // AddSearch search result click event
    const searchResults = document.querySelectorAll('#nav-site-search-results .search-results-list article')
    searchResults.forEach(article => {
      const linkElement = article.querySelector('a');
      if (!linkElement) return;
      linkElement.addEventListener('click', (event) => {
        event.preventDefault();
        const id = article.dataset.documentId;
        const href = linkElement.getAttribute('href');
        const position = !isNaN(article.dataset.index) ? parseInt(article.dataset.index) + 1 : false;
        const isNavSearchResultClicked = article.closest('#nav-site-search-results');
        const searchValue = getSearchValue(isNavSearchResultClicked);
        if (id && position && searchValue) {
          addSearchClient.sendStatsEvent('click', searchValue, {documentId: id, position: position})
        }
        if (searchValue && searchResults.length && href) {
          window.dataLayer.push({
            event: 'view_search_results',
            gtm: {
              search_or_click: 'click',
              search_term: searchValue,
              num_results: searchResults.length,
              url: href,
            }
          });
        }
        window.location.href = linkElement.href;
      })
    })

    // Google datalayer view_search_results
    const searchValue = getSearchValue(true);
    if (searchValue && searchResults.length) {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        window.dataLayer.push({
          event: 'view_search_results',
          gtm: {
            search_or_click: 'search',
            search_term: searchValue,
            num_results: searchResults.length,
          }
        });
      }, 1000);
    }
  }

  /**
   * Get elements by class name and search type, keyed by category.
   *
   * @param  {string}  className    - Class name to get elements by.
   * @param  {boolean} getInnerHTML - Get inner HTML instead of element.
   * @return {Object}  Elements keyed by search category.
   */

  getSearchResultElements(className, getInnerHTML = false) {
    const searchResultElements = document.getElementsByClassName(className);

    return searchResultElements.length ? Array.from(searchResultElements)
      .filter(({dataset: { searchType }}) => !searchType || searchType === this.searchType)
      .reduce((elements, element) => ({
        ...elements,
        [element.dataset.searchCategory]: getInnerHTML ? element.innerHTML : element
      }), {}) : {};
  }

  /**
   * Toggle progress bar visibility and animation.
   *
   * @param  {boolean}   shouldShow - Show or hide progress bar.
   * @return {undefined}
   */

  toggleProgressBarVisibility(shouldShow = true) {
    if (shouldShow) {
      this.elements.searchResults.classList.add('loading');
      this.elements.progressBar.classList.add('animate');
    }
    else {
      this.elements.searchResults.classList.remove('loading');
      this.elements.progressBar.classList.remove('animate');
    }
  }
}

export default SiteSearch;
